import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { animateScroll } from 'react-scroll';
import Section from 'components/Section';
import TextField from 'components/TextField';
import NavigationButtons from 'components/NavigationButtons';
import i18n from 'utils/translate';
import { noNumbers, numberTwelveDigits, numbersOnly } from 'utils/validators';
import { toast } from 'react-toastify';
import ErrorMessage from 'components/ErrorMessage';
import { linkTypeShape } from 'utils/types';
import { insuranceTypes } from '../../constants';
import RadioButton from 'components/RadioButton';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  backLink: PropTypes.shape(linkTypeShape).isRequired,
  nextLink: PropTypes.shape(linkTypeShape).isRequired
};

const defaultProps = {
  onChange: console.log,
  data: {}
};

class PaymentData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props.data,
      submitted: false,
      validForm: false
    };
  }

  handleSubmit = () => {
    const {
      nextLink: { go } = {
        go: () => {}
      },
      onChange
    } = this.props;
    const form = this.refs.form;
    const premiumRef = this.refs.premium;

    if (premiumRef?.autonumeric.getNumber() <= 0) {
      this.setState({
        validForm: false
      });
      return;
    }

    if (form.checkValidity && !form.checkValidity()) {
      form.reportValidity();
      return;
    }

    this.setState(
      {
        premium: premiumRef?.autonumeric.getNumber()
      },
      () => {
        onChange(this.state);

        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'onlinepayment',
            formname: 'OnlineFormMacedonia',
            action: 'Ihre Daten'
          });
        }

        go();
      }
    );
  };

  handleDataChange = (data, key) => {
    const { submitted } = this.state;

    this.setState(
      {
        [`${key}`]: data
      },
      () => {
        if (submitted) {
          this.setState({
            validForm: this.refs.form.checkValidity()
          });
        }
      }
    );
  };

  handlePaymentInfoChange = data => {
    const { submitted } = this.state;
    this.setState({ ...data }, () => {
      if (submitted) {
        this.setState({
          validForm: this.refs.form.checkValidity()
        });
      }
    });
  };

  componentDidMount() {
    animateScroll.scrollToTop({ duration: 0 });
  }

  render() {
    const {
      type,
      firstname,
      lastname,
      email,
      birthdate,
      paymentReference,
      premium,
      premiumPayment,
      submitted,
      validForm
    } = this.state;
    const { backLink } = this.props;

    return (
      <form
        className={`page-step-wrapper page-step-wrapper--narrow ${submitted ? 'submitted' : ''}`}
        ref="form"
        onSubmit={this.handleSubmit}
      >
        <Section header={i18n('Payment Details')}>
          <TextField
            label={i18n('Name and Surname')}
            name="first_name"
            className="col-xs-12 col-md-6"
            value={firstname && lastname ? `${firstname} ${lastname}` : 'John Doe'}
            ref="name"
            disabled={true}
          />
          <TextField
            label={i18n('Email')}
            name="email"
            className="col-xs-12 col-md-6"
            value={email}
            ref="email"
            disabled={true}
          />
          {type === insuranceTypes.policyNumber && (
            <TextField
              label={`${i18n('Premium value')} (MKD)`}
              name="premium"
              className="col-xs-12 col-md-6"
              value={premium}
              ref="premium"
              currencyInput
              disabled={true}
            />
          )}
          <TextField
            label={`${i18n('Field for Premium Payment')} (MKD)`}
            name="premiumPayment"
            className="col-xs-12 col-md-6"
            value={premiumPayment}
            ref="premiumPayment"
            currencyInput
            required
            onChange={data => this.handleDataChange(data, 'premiumPayment')}
            min={300}
          />
        </Section>
        <Section header={i18n('Payment Method')}>
          <RadioButton
            id="paymentCard"
            text={i18n('Kreditkarte')}
            defaultChecked={true}
            checked={true}
            readOnly={true}
            onChange={data => this.handleDataChange(data, 'paymentMethod')}
          />
        </Section>
        <NavigationButtons
          backLink={backLink}
          nextLink={{
            go: e => {
              this.setState({
                submitted: true,
                validForm: this.refs.form.checkValidity && this.refs.form.checkValidity()
              });

              Object.keys(this.refs).forEach(key => {
                if (this.refs[key].onBlur) {
                  this.refs[key].onBlur();
                }
              });

              if (this.refs.form.checkValidity && this.refs.form.checkValidity()) {
                toast.dismiss();
                this.handleSubmit();
              } else {
                toast.error(<ErrorMessage message={i18n('Bitte überprüfen Sie Ihre Angaben')} />);
              }
            }
          }}
        />
      </form>
    );
  }
}

PaymentData.defaultProps = defaultProps;
PaymentData.propTypes = propTypes;

export default PaymentData;
